module.exports = require('./libheif-wasm/libheif-bundle.js')();
